import ControllerBase from 'global/js/ControllerBase';

export default class ControllerProfileSliders extends ControllerBase {
	private activeSlide = 0;
	private buttonLeft;
	private buttonRight;
	private containerWidth;
	private imageContainer;
	private imageList;
	private imageWidths = [] as number[];
	private sliderWidth;
	private sliderWidthExceptLast;
	private stop = false;

	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private init() {
		this.imageContainer = this.$element.querySelector('.m-fhw-profile-sliders__image-container') as HTMLElement;
		this.imageList = this.$element.querySelectorAll('.image-wrapper');
		this.buttonLeft = this.$element.querySelector('.scroller-left');
		this.buttonLeft?.addEventListener('click', () => {
			this.stop = true;
			--this.activeSlide;
			this.scrollToSlide();
		});
		this.buttonRight = this.$element.querySelector('.scroller-right');
		this.buttonRight?.addEventListener('click', () => {
			this.stop = true;
			++this.activeSlide;
			this.scrollToSlide();
		});
		this.buttonHandlear();
		this.imageContainer.addEventListener('scroll', () => this.getCurrentSlide());
		window.addEventListener('resize', () => this.buttonHandlear(), false);
	}

	private getCurrentSlide() {
		if (this.stop) return;
		const scrollLeft = this.imageContainer.scrollLeft;
		let width = 32;
		for (const key in this.imageWidths) {
			width += this.imageWidths[key];
			if (scrollLeft < width) {
				this.activeSlide = parseInt(key);
				break;
			}
		}
		this.checkButtons();
	}

	private checkButtons() {
		const scrollLeft = this.imageContainer.scrollLeft;
		if (this.sliderWidth - 40 < scrollLeft + this.containerWidth) this.buttonRight.classList.add('scroller--disabled');
		else this.buttonRight.classList.remove('scroller--disabled');
		if (this.activeSlide < 1) this.buttonLeft.classList.add('scroller--disabled');
		else this.buttonLeft.classList.remove('scroller--disabled');
	}

	private scrollToSlide() {
		const scrollLeft = this.imageWidths?.slice(0, this.activeSlide)?.reduce((acc, cur) => acc + cur, 0);
		this.imageContainer.scrollTo(scrollLeft - 15, 0);
		setTimeout(() => {
			this.stop = false;
			this.checkButtons();
		}, 700);
	}

	private buttonHandlear() {
		const sliderButtons = this.$element.querySelector('.m-fhw-profile-sliders__nav');
		this.containerWidth = this.imageContainer ? this.imageContainer.clientWidth : 0;
		this.imageList.forEach((element) => this.imageWidths.push(element.clientWidth));
		this.sliderWidth = this.imageWidths.reduce((acc, cur) => acc + cur, 32);
		this.sliderWidthExceptLast = this.imageWidths.slice(0, this.imageWidths.length - 1).reduce((acc, cur) => acc + cur, 32);
		this.containerWidth <= this.sliderWidth ? sliderButtons?.classList.remove('hide-button') : sliderButtons?.classList.add('hide-button');
		this.getCurrentSlide();
	}
}
